import {Promo, TopupManager} from "../component/topup";
import {ToastManager} from "./toast-manager";
import {Translator} from "../utils/translator";
import logging from "../utils/log";
export class ModeControls
{
	private TAG = "ModeControls";
	private currentAmountID = 0;
	private promo : Promo;

	constructor(private $root : JQuery,
	            private toast : ToastManager,
	            private t : Translator,
	            private topup : TopupManager
	)
	{
		const $qb = this.$root.find(".sxccm-qb");

		this.$root.find(".sxccm-qb").mouseenter(() => {
			if ($qb.prop("disabled")) return;
			this.showToast();
		});

		this.$root.find(".arrow.top").click(() => {
			if ($qb.prop("disabled")) return;
			this.selectAmount(1);
			this.showToast();
		});

		this.$root.find(".arrow.bottom").click(() => {
			if ($qb.prop("disabled")) return;
			this.selectAmount(-1);
			this.showToast();
		});

		this.$root.find(".sxccm-qb-open").on("mousewheel", (e) => {
			if ($qb.prop("disabled")) return;
			const event = <any> e.originalEvent;
			const d = event.wheelDelta || -event.detail;

			this.selectAmount(d > 0 ? 1 : -1);
			this.showToast();
		});

		let $amt = this.$root.find(".amount");

		$amt.click(() =>
		{
			if (!this.topup) return;
			if ($qb.prop("disabled")) return;

			const amounts = this.topup.getData("creditcard").items;

			if (amounts[this.currentAmountID])
			{
				this.temporaryDisableQB(true);

				setTimeout(() =>
				{
					this.topup.getSecurionPayHandler().doQuickBuy(amounts[this.currentAmountID].credit, {}, (success, data) =>
					{
						this.temporaryDisableQB(false);
						if (success) {
							this.toast.push(data, {timeout: 7000, instant: true});
						} else {
							this.toast.push(data, {timeout: 7000, instant: true, strong: true});
						}
					});

				}, 3000);
			}
		});
	}

	temporaryDisableQB(disabled : boolean)
	{
		this.$root.find(".sxccm-qb")
			.prop("disabled", disabled)
			[disabled ? "addClass" : "removeClass"]("sxc-disabled")
		;
	}

	setMode(mode : string, pom : boolean = null)
	{
		logging.log(this.TAG, "setMode", mode);

		if (mode)
		{
			let modeText = this.t.t("mode_bar_mode_" + mode);

			if (pom) {
				modeText = this.t.t("mode_bar_mode_pom")
			}

			this.$root.attr("data-mode", mode);
			this.$root.find(".sxccm-mode")
				.addClass("sxc-visible")
				.text(modeText);
		}
		else
		{
			this.$root.removeAttr("data-mode");
			this.$root.find(".sxccm-mode").removeClass("sxc-visible");
		}
	}

	setSpecial(special : string, enabled : boolean) {
		logging.log(this.TAG, "setSpecial", special, enabled);
		this.$root[enabled ? "addClass" : "removeClass"]("sxccm-special-" + special);
	}

	setEnabled(enabled : boolean)
	{
		logging.log(this.TAG, "setEnabled", enabled);
		this.$root
			[enabled ? "addClass" : "removeClass"]("sxc-visible");
	}

	setQbEnabled(enabled : boolean) {
		logging.log(this.TAG, "setQbEnabled", enabled);
		this.$root.find(".sxccm-qb")
			[enabled ? "addClass" : "removeClass"]("sxc-visible");
	}

	selectAmount(d : number)
	{
		if (!this.topup) return;

		let cc = this.topup.getData("creditcard");
		let amounts = cc ? cc.items : null;

		if (amounts === null) return;

		this.currentAmountID += d;
		if (this.currentAmountID > amounts.length - 1) {
			this.currentAmountID = 0;
		}

		if (this.currentAmountID < 0) {
			this.currentAmountID = amounts.length - 1;
		}

		logging.log(this.TAG, "selectAmount", d, this.currentAmountID, amounts);

		let credit = this.promo
			? amounts[this.currentAmountID].credit + this.promo.getAmount(amounts[this.currentAmountID].credit)
			: amounts[this.currentAmountID].credit;

		this.$root.find(".sxccm-qb .amount").text(this.t.t(
			"mode_bar_amount_display",
			{amount: credit}))
	}

	showToast()
	{
		if (!this.topup) return;

		let amounts = this.topup.getData("creditcard").items;
		let item = amounts[this.currentAmountID];

		logging.log(this.TAG, "showToast", item, this.promo);

		let credit = this.promo
			? item.credit + this.promo.getAmount(item.credit)
			: item.credit;

		const msg = this.t.t(
			"mode_bar_amount_toast",
			{amount: credit});

		this.toast.push(msg, {timeout: 5000, instant: true});
	}

	update()
	{
		logging.log(this.TAG, "update");
		this.selectAmount(0);
	}

	updatePromo(promo: Promo)
	{
		logging.log(this.TAG, "updatePromo", promo);
		this.promo = promo;
		this.update();
	}
}
